import {useSelector} from 'react-redux';

import {userSelector, isUnderLimit} from 'entities/user';

import {serverAPI} from '../api/serverAPI';

interface IUseCanCreateServerOptions {
    serversCount?: number,
}

const useCanCreateServer = ({serversCount}: IUseCanCreateServerOptions = {}): boolean => {
    const user = useSelector(userSelector);

    const {data: pagination} = serverAPI.useGetServersQuery({}, {skip: serversCount !== undefined});

    return isUnderLimit(user?.tariff?.server_max_count_limit, serversCount ?? pagination?.totalItems);
};

export default useCanCreateServer;
